import React, { useEffect, useState } from "react";
import {
  SelectComponentsWrapper,
  FilterSelectInput,
  ChangeShiftButton,
  GlobalSelectStyles,
} from "./RequestForChangeShift.style";
import {
  StyledButtonBack,
  Container,
  StyledReactSVG,
  Title,
  Text,
} from "../../Pages.style";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import backIcon from "../../../assets/images/icons/chevron-left-solid.svg";
import useShiftsChange from "../hooks/useChangeShifts";
import { useAuthStateValue } from "../../../context/AuthContext";
import ATextArea from "../../../core/components/inputs/textArea/ATextArea";
import { useHistory } from "react-router-dom";
import { MainFooter } from "../../dashboard/Dashboard.style";

const RequestForChangeShift = () => {
  const { t } = useTranslation();
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const { loggedUser } = useAuthStateValue();
  const [myShiftDay, setMyShiftDay] = useState();
  const [myShiftId, setMyShiftId] = useState();
  const [myShiftDate, setMyShiftDate] = useState();
  const [elseShift, setElseShift] = useState();
  const [elseShiftId, setElseShiftId] = useState();
  const [changeShiftDay, setChangeShiftDay] = useState(null);
  const [changeShiftDate, setChangeShiftDate] = useState();
  const [comment, setComment] = useState();
  const [isSending, setIsSending] = useState(false);
  const history = useHistory();
  const locationIdentificator = loggedUser?.extendUser?.locationIdentificator;
  const locationId = loggedUser?.locationsData?.find(
    (el) => el?.value === locationIdentificator
  )?.id;
  const userApplicantId = parseInt(loggedUser?.id, 10);
  const remainingDays = [];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const today = currentDate.getDate();
  const myShifts = [];
  const peopleForRequest = [];
  let buttonDisabled = true;
  let myShiftChosen = false;
  let changeShiftDayChosen = false;
  const formatDate = (dateString) => {
    if (dateString) {
      const [convertedDay, convertedMonth, convertedYear] =
        dateString.split(".");
      const convertedDate = new Date(
        `${convertedYear}-${convertedMonth}-${convertedDay}`
      );
      const formattedDate = convertedDate.toISOString().split("T")[0];
      return formattedDate;
    }
  };
  const formatedChangeShiftDate = formatDate(changeShiftDate);
  const {
    dataSource,
    version,
    sendRequest,
    error,
    requestList,
    controllersList,
  } = useShiftsChange({
    atcu: locationIdentificator,
    year,
    month,
    userId: loggedUser?.id,
    dateForControllers: formatedChangeShiftDate,
  });

  function addLeadingZero(n) {
    return n < 10 ? `0${n}` : n;
  }

  const remainingDaysOfMonthMyShift = () => {
    const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
    const nextMonthYear = currentMonth === 12 ? currentYear + 1 : currentYear;

    const currentMonthController = dataSource?.controllers?.find(
      (obj) => obj?.id == loggedUser?.id
    );
    if (currentMonthController?.shifts) {
      currentMonthController.shifts.forEach((item) => {
        if (item.date >= today) {
          const shiftData = {
            value: `${item.date}-${currentMonth}-${currentYear}`,
            shiftId1: item.shiftId,
            label: `${
              addLeadingZero(item.date) +
              "." +
              addLeadingZero(currentMonth) +
              "." +
              currentYear +
              "." +
              "(" +
              item.shiftName +
              ")"
            }`,
            date: item?.date,
            month: currentMonth,
            year: currentYear,
          };
          myShifts.push(shiftData);
        }
      });
    }

    // Get next month shifts if available
    if (today > 15 && dataSource?.nextMonthData) {
      const nextMonthController = dataSource.nextMonthData.controllers?.find(
        (obj) => obj?.id == loggedUser?.id
      );

      if (nextMonthController?.shifts) {
        nextMonthController.shifts.forEach((item) => {
          const shiftData = {
            value: `${item.date}-${nextMonth}-${nextMonthYear}`,
            shiftId1: item.shiftId,
            label: `${
              addLeadingZero(item.date) +
              "." +
              addLeadingZero(nextMonth) +
              "." +
              nextMonthYear +
              "." +
              "(" +
              item.shiftName +
              ")"
            }`,
            date: item?.date,
            month: nextMonth,
            year: nextMonthYear,
          };
          myShifts.push(shiftData);
        });
      }
    }
  };

  const remainingDaysForChangingShift = () => {
    remainingDays.length = 0;

    // Get the last day of the current month
    const lastDayOfCurrentMonth = new Date(
      currentYear,
      currentMonth,
      0
    ).getDate();

    // Calculate next month and year
    const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
    const nextMonthYear = currentMonth === 12 ? currentYear + 1 : currentYear;

    // Helper function to format date label
    const formatDateLabel = (day, month, year) => {
      return (
        addLeadingZero(day) + "." + addLeadingZero(month) + "." + year + "."
      );
    };

    // Add remaining days of current month
    for (let day = today + 1; day <= lastDayOfCurrentMonth; day++) {
      const label = formatDateLabel(day, currentMonth, currentYear);
      remainingDays.push({
        value: `${day}-${currentMonth}-${currentYear}`,
        day: day,
        label: label,
        month: currentMonth,
        year: currentYear,
        key: `current-${day}-${currentMonth}-${currentYear}`,
      });
    }

    if (today > 15) {
      const lastDayOfNextMonth = new Date(
        nextMonthYear,
        nextMonth,
        0
      ).getDate();
      for (let day = 1; day <= lastDayOfNextMonth; day++) {
        const label = formatDateLabel(day, nextMonth, nextMonthYear);
        remainingDays.push({
          value: `${day}-${nextMonth}-${nextMonthYear}`,
          day: day,
          label: label,
          month: nextMonth,
          year: nextMonthYear,
          key: `next-${day}-${nextMonth}-${nextMonthYear}`,
        });
      }
    }

    return remainingDays;
  };

  remainingDaysOfMonthMyShift();
  remainingDaysForChangingShift();

  controllersList?.data?.forEach((item) => {
    peopleForRequest?.push({
      name: item.fullName,
      label: item.fullName + " (" + item.shiftName + ")",
      shiftId2: item.shiftId,
      value: item.id,
      day: item.date,
      userRecipientRequestId: item.id,
    });
  });

  const myShiftFunction = (value) => {
    const [dayStr, monthStr, yearStr] = value.split("-");
    const day = parseInt(dayStr);
    const month = parseInt(monthStr);
    const year = parseInt(yearStr);

    setMyShiftDay(value);
    const helper = myShifts?.find(
      (el) => el.date === day && el.month === month && el.year === year
    );
    setMyShiftId(helper?.shiftId1);
    setMyShiftDate(helper?.label);
  };

  if (myShiftId !== null) {
    myShiftChosen = true;
  }

  const changeShiftDayFunction = (value) => {
    const [dayStr, monthStr, yearStr] = value.split("-");
    const day = parseInt(dayStr);
    const month = parseInt(monthStr);
    const year = parseInt(yearStr);

    setChangeShiftDay(day);

    const helper = remainingDays?.find(
      (el) => el.day === day && el.month === month && el.year === year
    );

    if (helper) {
      const formattedDate = `${addLeadingZero(day)}.${addLeadingZero(
        month
      )}.${year}.`;
      setChangeShiftDate(formattedDate);
    }

    setElseShift(undefined);
    setElseShiftId(undefined);
  };

  if (changeShiftDay !== null) {
    changeShiftDayChosen = true;
  }

  const changeShiftPersonFunction = (value) => {
    const helper = peopleForRequest?.find((el) => el.value === value);
    setElseShift(value);
    setElseShiftId(helper?.shiftId2);
  };

  const commentHandler = (e) => {
    setComment(e.target.value);
  };

  if (elseShift !== undefined && comment !== undefined) {
    buttonDisabled = false;
  }

  const sendRequestHandler = async () => {
    setIsSending(true);

    const params = {
      userApplicantId: userApplicantId,
      userRecipientRequestId: elseShift,
      date1: formatDate(myShiftDate),
      shiftConfigId1: myShiftId,
      date2: formatDate(changeShiftDate),
      shiftConfigId2: elseShiftId,
      comment: comment,
    };

    try {
      await sendRequest(params);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Container>
      <GlobalSelectStyles />
      <Title>
        <StyledButtonBack>
          <NavLink to="/changeShift">
            <StyledReactSVG src={backIcon}></StyledReactSVG>
          </NavLink>
        </StyledButtonBack>
        <Text>{t("changeShift.requestForChangeShift")}</Text>
      </Title>
      <SelectComponentsWrapper>
        <Text style={{ fontSize: "18px", marginTop: "8px" }}>
          {t("requestForChangeShift.myShift")}
        </Text>
        <FilterSelectInput
          options={myShifts}
          listHeight={150}
          onChange={myShiftFunction}
        ></FilterSelectInput>
        <Text style={{ fontSize: "18px", marginTop: "8px" }}>
          {t("requestForChangeShift.changeShiftDay")}
        </Text>
        <FilterSelectInput
          options={remainingDays}
          disabled={!myShiftChosen}
          onChange={(value) => {
            changeShiftDayFunction(value);
          }}
          listHeight={150}
        ></FilterSelectInput>
        {changeShiftDayChosen && (
          <Text style={{ fontSize: "18px", marginTop: "8px" }}>
            {t("requestForChangeShift.changeShiftPerson")}
          </Text>
        )}
        {changeShiftDayChosen && (
          <FilterSelectInput
            options={peopleForRequest}
            value={elseShift}
            onChange={changeShiftPersonFunction}
            listHeight={150}
          ></FilterSelectInput>
        )}
        {changeShiftDayChosen && (
          <Text style={{ fontSize: "18px", marginTop: "8px" }}>
            {t("requestForChangeShift.explanation")}
          </Text>
        )}
        {changeShiftDayChosen && (
          <ATextArea
            rows={4}
            // style={{ width: "100%" }}
            onChange={commentHandler}
          />
        )}
        <ChangeShiftButton
          style={{ width: "200px", height: "50px", marginBottom: "50px" }}
          onClick={sendRequestHandler}
          disabled={buttonDisabled || isSending}
        >
          {t("requestForChangeShift.sendRequest")}
        </ChangeShiftButton>
      </SelectComponentsWrapper>
      <MainFooter
        style={{ height: "55px", backgroundColor: "#185da9" }}
      ></MainFooter>
    </Container>
  );
};
 
export default RequestForChangeShift;